import { Client } from "@smash-sdk/core";
import { HttpRequest, SDKError, config } from "@smash-sdk/core";
import { errors } from "./errors";
export * from "./errors";
export * from "./types/ListPublicServices/ListPublicServices";
const endpoints = {
    "ca-central-1": "https://discovery.ca-central-1.fromsmash.co",
    "eu-central-1": "https://discovery.eu-central-1.fromsmash.co",
    "eu-west-1": "https://discovery.eu-west-1.fromsmash.co",
    "eu-west-2": "https://discovery.eu-west-2.fromsmash.co",
    "eu-west-3": "https://discovery.eu-west-3.fromsmash.co",
    "us-east-1": "https://discovery.us-east-1.fromsmash.co",
    "us-east-2": "https://discovery.us-east-2.fromsmash.co",
    "us-west-1": "https://discovery.us-west-1.fromsmash.co",
    "us-west-2": "https://discovery.us-west-2.fromsmash.co",
};
config.setHosts("discovery", endpoints, false);
export class Discovery extends Client {
    constructor(params = {}) {
        super({ service: "discovery", ...params, type: "regional", userAgent: "@smash-sdk/discovery@1.0.0-alpha.2" });
        this.errors = errors;
    }
    listPublicServices() {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/namespace/public/services",
                    headers: {},
                    pathParameters: {},
                    queryParameters: {
                        version: "02-2023",
                    },
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListPublicServicesError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
}
Discovery.errors = errors;
